import { TFunction } from 'i18next';
import { TNamespaceEnum } from 'types/types';
import { getTranslation } from 'utils/localization';

export const getGenderSelectValues = (
    t: TFunction
): { label: string; value: string }[] => [
    {
        label: getTranslation(t, TNamespaceEnum.person, 'male'),
        value: 'male',
    },
    {
        label: getTranslation(t, TNamespaceEnum.person, 'female'),
        value: 'female',
    },
];
